import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import PartCheckModal from '../stock/partCheckModal';
import Detail from './detail';
import DeleteModal from './deleteModal';
import './detailManagement.scss';

class ManagementDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentDidMount() {
    const {selectedOrder, permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.ProviderOrdersDetail, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    if (selectedOrder) {
      this.props.getProviderOrderDetail(selectedOrder.orderCode);
    }
  }

  componentWillUnmount() {
    this.props.clearProviderOrderDetail();
  }

  handleBackClick() {
    this.props.navigateTo(paths.ProviderOrdersManagement);
  }

  renderOrderDetail() {
    const {selectedOrder, orderLines, origin} = this.props;

    if (!selectedOrder) {
      return (
        <Card raised fluid className='head-section'>
          <h2>No se puede mostrar el detalle del pedido</h2>
          <span className='provider-order-info'>
            No se ha seleccionado ningún pedido para la revisión de su detalle.
          </span>
        </Card>
      );
    }

    return (
      <React.Fragment>
        <Card raised fluid className='head-section'>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <h2>
                  <Icon link color='black' className='arrow left' onClick={this.handleBackClick} />
                  Detalle del pedido {selectedOrder.orderCode}
                </h2>
                <span className='provider-order-info'>
                  {selectedOrder.providerName} | {selectedOrder.creationDate} | {origin} | {orderLines} Líneas
                </span>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Detail />
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className='provider-orders-detail-management'>
        <DeleteModal />
        <PartCheckModal />
        {this.renderOrderDetail()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {list = [], origin, selectedOrder} = state.providersOrdersManagementDetail;

  return {
    'permissions': state.session.permissions,
    'orderLines': list.length,
    selectedOrder,
    origin,
  };
};

const {
  getProviderOrderDetail,
  clearProviderOrderDetail,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getProviderOrderDetail,
  clearProviderOrderDetail,
  navigateTo,
})(ManagementDetail);
